import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import { useRouter } from 'next/router';
import { useApolloClient, useMutation } from '@apollo/client';
import FloatingButton from '@fuww/library/src/Button/FloatingButton';
import { useSiteContext } from '../../SiteContext';
import { Link } from '../../../routes';
import addUTMSource from '../../../lib/addUtmSource';
import getJobEventTracker from '../../../lib/getJobEventTracker';
import messages from '../../../lib/messages';
import increaseJobApplyButtonClicks
  from '../../../lib/queries/jobs/increaseJobApplyButtonClicksMutation.graphql';
import { JobProperties } from './JobProperties';

const ApplyButton = ({ job }: { job?: JobProperties | null }) => {
  const { locale } = useSiteContext();
  const { query: { slug } } = useRouter();
  const intl = useIntl();
  const [increaseApplyButtonClicks] = useMutation(increaseJobApplyButtonClicks);
  const apolloClient = useApolloClient();

  const {
    applyForm,
    applyUrl,
    id,
  } = { ...job };

  const applyButtonTracker = applyForm
    ? getJobEventTracker(
      apolloClient,
      'Meteor Job universal apply button',
      job,
    )
    : getJobEventTracker(
      apolloClient,
      'Meteor Job apply button',
      job,
    );

  const button = (
    <FloatingButton
      component="a"
      variant="extended"
      color="primary"
      onClick={() => {
        increaseApplyButtonClicks({
          variables: {
            id,
          },
        });
        applyButtonTracker();
      }}
      target={applyForm ? null : '_blank'}
      rel={applyForm ? null : 'noopener noreferrer'}
      href={applyUrl ? addUTMSource(applyUrl) : undefined}
    >
      {intl.formatMessage(messages.applyButtonText)}
    </FloatingButton>
  );

  return applyForm ? (
    <Link
      {...{ route: `job-apply.${locale}`, params: { id: String(id), slug } }}
      passHref
    >
      {button}
    </Link>
  ) : button;
};

ApplyButton.propTypes = {
  job: PropTypes.shape({
    applyForm: PropTypes.bool,
    applyUrl: PropTypes.string,
    id: PropTypes.number,
  }).isRequired,
};

export default ApplyButton;
